import {
    type EntityRecordResponse,
    EntityType,
    type JobEntityRecordResponse,
    type SpecificationResponse,
} from "handlers";

/**
 * Converts a SpecificationResponse to an EntityRecordResponse
 * for use with EntityLinkSelector cache updates.
 */
export function toEntityRecord(spec: SpecificationResponse): EntityRecordResponse {
    const jobRecord: JobEntityRecordResponse = {
        id: spec.externalId,
        title: spec.title ?? "",
        entityId: spec.id,
        entityType: EntityType.Specification,
        organizationId: spec.builderId,
        jobId: spec.jobId,
        status: spec.status,
        isDeleted: false,
        entityRecordResponseType: "job",
    };
    return jobRecord;
}
